import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { useNavigate, useLocation } from "react-router-dom";
import { Avatar, Dropdown, Menu } from "antd";
import { useIntl } from "react-intl";
import styled from "styled-components";
import bizGive from "../assets/BizGive_logo_final.png";
import userIcon from "../assets/person.svg";
import { useAppDispatch } from "../redux/store";
import StyledText from "./StyledText";
import { getLocalStorageItem, removeQueryParam } from "../utils/utilities";
import { resetState } from "../redux/actions";

const Header = ({ className, menuCollapsed }) => {
  const intl = useIntl();
  const [tokenAvailable, setTokenAvailable] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const hiddenSideNavPaths = ["/share/verification/", "/share/confirmation", "/share/preapproved/"];
  const shouldHideSideNav = hiddenSideNavPaths.some((path) =>
    location.pathname.startsWith(path)
  );

  const hideName = ["/login"]?.includes(location?.pathname);
  const hideLoginButtons =
    ["/forgot-password", "/create-password", "/public/"]?.includes(location?.pathname) || shouldHideSideNav;

  useEffect(() => {
    const isTokenAvailable = window.localStorage.getItem("id_Token");
    setTokenAvailable(!!isTokenAvailable);
  }, [location]);

  const menu = (
    <Menu onClick={(e) => handleMenuClick(e)} className="logoutMenu">
      <Menu.Item key="logout" >{intl.formatMessage({ id: "logout" })}</Menu.Item>
    </Menu>
  );

  const handleMenuClick = (e) => {
    if (e.key === "logout") {
      dispatch(resetState());
      localStorage.clear();
      sessionStorage.clear();
      window.open(`${window.location.origin}/`, "_self");
      removeQueryParam();
    }
  };

  const handleUserDetails = (page) => {
    if (page === "login") {
      navigate(`/`);
      removeQueryParam();
    } else {
      navigate(`/signup`);
      removeQueryParam();
    }
  };

  const baseClassName = clsx("header", className);

  return (
    <div className={baseClassName}>
      <Avatar src={bizGive} shape="square" className="logo" />
      {!hideLoginButtons && tokenAvailable ? (
        <div className="userNameContainer">
          <Dropdown overlay={menu} trigger={["hover"]}>
            <div className="userDropdown">
              {(!hideName || !shouldHideSideNav) && getLocalStorageItem("user_details") && (
                <span className="userName">{getLocalStorageItem("user_details")}</span>
              )}
              <Avatar src={userIcon} className="userIcon" />
            </div>
          </Dropdown>
        </div>
      ) : (
        (!hideLoginButtons && !/public/.test(location?.pathname)) && (
          <div className="loginAndSignUp">
            <button onClick={() => handleUserDetails("login")}>
              <StyledText as="p" variant="H2" className="title">
                {intl.formatMessage({ id: "login" })}
              </StyledText>
            </button>
            <button onClick={() => handleUserDetails("signUp")}>
              <StyledText as="p" variant="H2" className="signUp">
                {intl.formatMessage({ id: "sign_up" })}
              </StyledText>
            </button>
          </div>
        )
      )}
    </div>
  );
};

const StyledHeader = styled(Header)`
  &.header {
    background-color: #fff;
    position: sticky;
    border-top: 4px solid #04ac9c;
    box-shadow: 0 1px 8px #d7dde1;
    top: 0;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    position: fixed;
    top: 0px;
    z-index: 99999;
    width: 100%;
    height: 60px;
    .userNameContainer {
      display: flex;
      align-items: center;
      gap: 20px;
      .userDropdown {
        display: flex;
        align-items: center;
        gap: 20px;
        cursor: pointer;
        margin-right: 10px;
      }
      .userName {
        color: #04ac9c;
      }
    }

    .logo {
      height: 46px;
      width: 180px;
      background: #fff;
      border-radius: 0;
      &.collapsed {
        width: 80px;
      }
      img {
        object-fit: contain;
        transform: scale(0.7);
      }
    }
    .loginAndSignUp {
      display: flex;
      margin-right: 15px;
      gap: 20px;
      button {
        border: 0;
        background: transparent;
        cursor: pointer;
        p {
          color: #04ac9c;
        }
      }
    }
  }
`;

export default StyledHeader;
